/**
 * Fallback-only constants.
 *
 * `MARKETING_DOMAIN` is sourced from the `marketing_domain_url` row in the
 * `app_settings` table — read it via `useAppSettings()` (or `useSetting`) in
 * React components. This constant is the last-resort fallback used when the
 * setting is missing, still loading, or the component cannot use React hooks.
 *
 * Do NOT import this for production reads from new components; use the hook.
 */
export const MARKETING_DOMAIN = "https://tristanoscatering.ca";
